import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAsterisk: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAsterisk"><Path fillRule="evenodd" clipRule="evenodd" d="M12.9969 2V10.2675L20.1564 6.13397L21.1564 7.86603L13.9965 11.9998L21.1571 16.134L20.1571 17.866L12.9969 13.7321V22H10.9969V13.7317L3.83594 17.866L2.83594 16.134L9.99654 11.9998L2.83663 7.86603L3.83663 6.13397L10.9969 10.2679V2H12.9969Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAsterisk;
